<template>
    <FormField v-slot="{ inputId, touch }" :required v-bind="otherProps">
        <input :id="inputId" v-model="model" :type :required @blur="touch" @change="touch" />
    </FormField>
</template>
<script setup lang="ts">
import type { FormInputProps } from "~/utils/types/FormFieldProps";

const model = defineModel<string | number>();

const { type = "text", required = true, ...otherProps } = defineProps<FormInputProps>();
</script>
